import { createRoutine } from 'redux-saga-routines';
import {
  GET_COMPANIES_COUNTRIES,
  GET_COMPANIES_BY_SLUG,
  GET_COMPANIES_PRODUCTIONS,
  GET_COMPANIES_SEARCH,
} from './constants';

export const getCompaniesSearchAction = createRoutine(GET_COMPANIES_SEARCH);
export const getCompaniesBySlugAction = createRoutine(GET_COMPANIES_BY_SLUG);
export const getCompaniesCountriesAction = createRoutine(GET_COMPANIES_COUNTRIES);
export const getCompaniesProductionsAction = createRoutine(GET_COMPANIES_PRODUCTIONS);
